import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Pages.css';
import { ROUTES } from '../routes';

const pressBase = `${process.env.PUBLIC_URL}/assest/press`;
const buniLogo = `${process.env.PUBLIC_URL}/assest/img/buni logo.png`;

const pressDocuments = [
  {
    id: 1,
    title: '1st Press Release',
    category: 'UNVEIL Press Conference',
    description: 'UNI HUBS first press release from the UNVEIL Press Conference.',
    filename: 'UNIHUBS_1st_press_release.pdf.pdf',
  },
  {
    id: 2,
    title: '2nd Press Release',
    category: 'UNVEIL Press Conference',
    description: 'UNI HUBS second press release from the UNVEIL Press Conference.',
    filename: 'UNIHUBS_2nd_press_release.pdf',
  },
  {
    id: 3,
    title: '3rd Press Release',
    category: 'UNVEIL Press Conference',
    description: 'UNI HUBS third press release from the UNVEIL Press Conference.',
    filename: 'UNIHUBS_3rd_press_release.pdf.pdf',
  },
  {
    id: 4,
    title: '4th Press Release',
    category: 'UNVEIL Press Conference',
    description: 'UNI HUBS fourth press release from the UNVEIL Press Conference.',
    filename: 'UNIHUBS_4th_press_release.pdf.pdf',
  }
];

const PressConference = () => {
  const navigate = useNavigate();
  const getDocumentUrl = (filename) =>
    `${pressBase}/${encodeURIComponent(filename)}`;

  const handleDownload = (filename) => {
    const link = document.createElement('a');
    link.href = getDocumentUrl(filename);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="framework-page">
      <section className="framework-hero-compact">
        <div className="framework-hero-container">
          <button
              type="button"
              className="press-back-button"
              onClick={() => navigate(ROUTES.mediaRelations)}
            >
              <i className="fas fa-arrow-left"></i>
              Back to Media Relation
            </button>
          <h1 className="framework-hero-title">UNVEIL Press Conference</h1>
          <p className="framework-hero-subtitle">
            Press releases and publications from the UNVEIL Press Conference
          </p>
        </div>
      </section>

      <section className="framework-content-compact">
        <div className="framework-container">
          <div className="press-documents-grid">
            {pressDocuments.map((doc) => (
              <article key={doc.id} className="press-card">
                <div className="press-card-icon">
                  <img src={buniLogo} alt="Buni logo" className="press-card-logo" />
                </div>
                <div className="press-card-body">
                  <span className="press-card-category">{doc.category}</span>
                  <h3 className="press-card-title">{doc.title}</h3>
                  <p className="press-card-description">{doc.description}</p>
                </div>
                <div className="press-card-actions">
                  <a
                    className="press-btn press-btn-outline"
                    href={getDocumentUrl(doc.filename)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="fas fa-eye"></i>
                    View
                  </a>
                  <button
                    type="button"
                    className="press-btn press-btn-primary"
                    onClick={() => handleDownload(doc.filename)}
                  >
                    <i className="fas fa-download"></i>
                    Download
                  </button>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default PressConference;
